<template>
	<page-container
		class="container"
		:page="page"
		:class="{ 'no-heading-image': !page.headingImage, 'no-video': !page.embedCode }"
	>
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageAlt: page.headingImageAlt,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitAlt: page.headingImagePortraitAlt,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content>
			<div class="columns column12 align-center extra-margin">
				<h1>{{ page.title || page.header }}</h1>

				<wysiwyg-content :content="page.content" />
			</div>
		</main-content>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>

		<footer-image
			v-if="page.footerImage?.length"
			:image="{
				image: page.footerImage,
				imageWebp: page.footerImageWebp,
				imageAlt: page.footerImageAlt,
			}"
		/>
	</page-container>
</template>

<script setup lang="ts">
const { page, fetchPage } = usePage();

await fetchPage();

useHead({
	bodyAttrs: {
		class: 'menu subpage',
	},
});
</script>

<style lang="scss" scoped>
.button,
:deep(.button) {
	margin: 15px;
}

.extra-margin {
	margin-bottom: 100px;
}
</style>
